export default __webpack_public_path__ + "static/media/paper-plane.9e8d13f9.png";